<template>
  <div class="header-user-sessions">
    <v-flex>
      <v-btn color='green' dark @click='fetchSessions()'>{{ $store.state.solver.toUpperCase() }}'S SESSIONS</v-btn>
    </v-flex>
  </div>
</template>

<script>
export default {
  name: 'header-user-sessions',
  data () {
    return {}
  },
  props: {
    pageType: String // eg. dashboard, session, etc.
  },
  methods: {
    fetchSessions () {
      this.$router.push({ path: `/sessions` })
    }
  }
}
</script>
